import React, { useState, useEffect, useContext, useRef } from "react";
import "./GithubStat.css";
import { ThemeContext } from "../../contexts/ThemeContext";

function GithubStat() {
  const { theme } = useContext(ThemeContext);
  const [loading, setLoading] = useState(true);
  
  const contribGraphRef1 = useRef(null);
  const contribGraphRef2 = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const targets = [contribGraphRef1.current, contribGraphRef2.current].filter(Boolean);
    if (targets.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [loading]);

  return (
    <section
      id="githubStats"
      className="github-section"
      style={{ backgroundColor: theme.secondary }}
    >
      <h2 className="github-heading" style={{ color: theme.tertiary }}>
        GitHub{" "}
        <span className="themeText" style={{ color: theme.primary }}>
          Statistics
        </span>
      </h2>

      {loading ? (
        <div className="loading-container">
          <div
            className="loading-spinner"
            style={{
              borderColor: `${theme.primary} transparent transparent transparent`,
            }}
          ></div>
          <p style={{ color: theme.tertiary }}>Loading GitHub statistics...</p>
        </div>
      ) : (
        <>
          {}
          <div className="github-stats-row">
            <div
              className="github-stat-card"
              style={{ backgroundColor: theme.primary, color: theme.secondary }}
            >
              <img
                src={`https://github-readme-stats.vercel.app/api/top-langs/?username=WhoAbdullahSheikh&layout=compact&theme=dark&border_radius=10&hide_border=true`}
                alt="Abdullah's most used languages"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <div className="fallback-text" style={{ color: theme.secondary }}>
                Language stats not available
              </div>
            </div>
            <div
              className="github-stat-card"
              style={{ backgroundColor: theme.primary, color: theme.secondary }}
            >
              <img
                src={`https://github-profile-summary-cards.vercel.app/api/cards/profile-details?username=WhoAbdullahSheikh&theme=dark`}
                alt="Abdullah's github Stats"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <div className="fallback-text" style={{ color: theme.secondary }}>
                Profile details not available
              </div>
            </div>
          </div>

          {}
          <div className="github-stats-row">
            <div
              className="github-stat-card"
              style={{ backgroundColor: theme.primary, color: theme.secondary }}
            >
              <img
                src={`https://github-readme-stats.vercel.app/api?username=WhoAbdullahSheikh&theme=dark&hide_border=true&include_all_commits=true&count_private=true&border_radius=10`}
                alt="Abdullah's github stats"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <div className="fallback-text" style={{ color: theme.secondary }}>
                GitHub stats not available
              </div>
            </div>
            <div
              className="github-stat-card"
              style={{ backgroundColor: theme.primary, color: theme.secondary }}
            >
              <img
                src={`https://github-readme-streak-stats.herokuapp.com/?user=WhoAbdullahSheikh&layout=compact&hide_border=true&theme=dark&border_radius=10`}
                alt="Abdullah's current Streaks"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <div className="fallback-text" style={{ color: theme.secondary }}>
                Streak stats not available
              </div>
            </div>
          </div>

          {}
          <div className="github-calendar-container">
            <h3
              className="contributions-heading"
              style={{ color: theme.tertiary }}
            >
              GitHub <span style={{ color: theme.primary }}>Contributions</span>
            </h3>
            <div className="contributions-graph-wrapper">
              <img
                ref={contribGraphRef1}
                className="reveal-on-scroll"
                src={`https://github-readme-activity-graph.vercel.app/graph?username=WhoAbdullahSheikh&bg_color=212121&color=ffffff&line=f56539&point=ffffff&area=true&hide_border=false`}
                alt="Abdullah's GitHub contributions"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />

              <div
                className="fallback-text"
                style={{
                  color: theme.secondary,
                  backgroundColor: theme.primary,
                }}
              >
                Contribution graph not available
              </div>
            </div>
            <p className="contributions-note" style={{ color: theme.tertiary }}>
              My GitHub contribution history
            </p>
          </div>

          {}
          <div className="github-calendar-container">
            <div className="contributions-graph-wrapper">
              <img
                ref={contribGraphRef2}
                className="reveal-on-scroll"
                src={`https://ghchart.rshah.org/${theme.primary.replace(
                  "#",
                  ""
                )}/WhoAbdullahSheikh`}
                alt="Abdullah's GitHub contributions"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />

              <div
                className="fallback-text"
                style={{
                  color: theme.secondary,
                  backgroundColor: theme.primary,
                }}
              >
                Contribution graph not available
              </div>
            </div>
            <p className="contributions-note" style={{ color: theme.tertiary }}>
              My GitHub contribution calender
            </p>
          </div>
        </>
      )}
    </section>
  );
}

export default GithubStat;
